import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useMemo } from 'react';
import { findThemeAppExtension } from '../integrationStatusUtils';
import { AppsEmbedIntegration } from './apps-embed-integration/AppsEmbedIntegration';
import { BlockEmbedIntegration } from './block-embed-integration/BlockEmbedIntegration';

export const CartIntegrations = ({
    extensions,
    isLoading,
    condensed,
    hideOptional,
    handleClickAddStoreAppBlock,
}: CartIntegrationsProps) => {
    const themeAppExtension = useMemo(() => findThemeAppExtension(extensions), [extensions]);

    return (
        <>
            <AppsEmbedIntegration
                themeAppExtension={themeAppExtension}
                isLoading={isLoading}
                condensed={condensed}
                handleClickAddStoreAppBlock={handleClickAddStoreAppBlock}
            />
            {!hideOptional && (
                <>
                    <s-divider />
                    <BlockEmbedIntegration
                        themeAppExtension={themeAppExtension}
                        isLoading={isLoading}
                        condensed={condensed}
                    />
                </>
            )}
        </>
    );
};

interface CartIntegrationsProps {
    extensions: ExtensionInfo[];
    isLoading: boolean;
    condensed?: boolean;
    hideOptional?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
